import type React from 'react';
import { useTranslation } from 'react-i18next';

import type { MenuNodeType } from 'types/app';

import { OfferSortEnum, OfferSortOptions } from '@Modules/offers/constants';

import { Dropdown } from '@Atomic/atoms/Dropdown';

import styles from './sortingDropdown.module.scss';
import { SortingTrigger } from './SortingTrigger';
import { useSorting } from './useSorting';

export const SortingDropdown: React.FC = () => {
  const { t } = useTranslation();
  const { sort, handleSortingUpdate } = useSorting();

  const buttonLabel = t(`sorting.${OfferSortEnum[sort].toLowerCase()}`);

  const menuItems = OfferSortOptions.map(
    ({ value, label, testId }) =>
      ({
        type: 'option',
        key: value.toString(),
        label: t(label),
        selected: sort === value,
        onClick: () => handleSortingUpdate(value),
        testId,
      }) as MenuNodeType
  );

  return (
    <Dropdown className={styles.dropdown} menu={menuItems}>
      <SortingTrigger>{buttonLabel}</SortingTrigger>
    </Dropdown>
  );
};
